<template>
    <div class="box" id="study-box" style="height:100vh;overflow: hidden;position: relative;">
        <div class="banner-course">
            <div class="back-box">
                <img src="../../assets/image/course/back.png" style="width: 2.6rem;" @click="toBack" alt="">
            </div>
            <div class="banner-title overflow">{{ (courseDetail.classifyName || '') + '/' + (courseDetail.courseName || '') }}
            </div>
            <div @click="openAi(true)" class="ai-cursor" style="margin-left: 6rem;display: flex;align-items: center;cursor: pointer;">
                <img style="width: 2.7rem;" src="../../assets/image/course/ai.png" alt="">
                <div class="grey">AI互动</div>
            </div>
        </div>
        <div class="box-content">
            <div class="left-content" :class="{ 'active-100': !showSlider }">
                <div class="preview-box" v-if="type == 'ppt'">
                    <div class="slider-box">
                        <div class="box-item">
                            <div v-for="(item, index) in studyCoursePreview" class="ppt-img-item" :key="index"
                                @click="changePpt(index)">
                                <img :class="{ 'active-ppt': index == currentPptPage - 1 }"
                                    :data-src="$severUrl(item.filePreviewUrl)" class="slider-img-item" :key="index"
                                    :src="$severUrl(item.filePreviewUrl)" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="show-content-box" :style="`width:${type=='ppt'?(showSlider ? 'calc(100% - 25rem)' : 'calc(100% - 20rem)'):'100%'};`">
                    <div class="tab-container" style="width:calc(100% - 9rem);">
                        <el-tabs v-model="preRes" disabled>
                            <el-tab-pane v-for="(item, index) in topRes" :key="index" :name="item.id">
                                <template slot="label">
                                    <div @click="viewResource(item)" style="display: flex;align-items: center;">
                                        <i class="iconfont" :class="filterIcon(item.type)"
                                            style="margin-right: 1rem;color: #BCC1D3;font-size: 16px;"></i>
                                        <el-tooltip v-if="item.type == '题库'" effect="dark" placement="top-start">
                                            <div slot="content">
                                                <div v-html="item.authStatus ? item.resourceName : '暂无权限'"></div>
                                            </div>
                                            <div v-html="item.resourceName"
                                                style="overflow: hidden;max-height: 2rem;max-width: 20rem;"
                                                :id="!item.authStatus ? 'disabled-color' : ''"
                                                :class="[{ 'disabled-btn': !item.authStatus }, { 'disabled-color': !item.authStatus }]"
                                                class="html-box-ev"></div>
                                        </el-tooltip>
                                        <el-tooltip id="tooltip" v-else effect="dark"
                                            :content="item.authStatus ? item.resourceName : '暂无权限'"
                                            placement="top-start">
                                            <div class="overflow" :id="!item.authStatus ? 'disabled-color' : ''"
                                                :class="[{ 'disabled-btn': !item.authStatus }, { 'disabled-color': !item.authStatus }]"
                                                style="color: #334681;max-width: 20rem;">{{
                                                    item.resourceName }}</div>
                                        </el-tooltip>
                                        <div style="width: 1px;height: 14px;background-color: #BCC1D3;margin-left: 2rem;"
                                            v-if="index < topRes.length - 1"></div>
                                    </div>
                                </template>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <i class="iconfont icon-jiantou_xiangyouliangci" :class="{ 'tranform-active': !showSlider }"
                        @click="changeSlider"></i>
                    <div class="content" :style="`padding-bottom:${type=='ppt'?'0':'2rem'}`">
                        <div class="r-box-p" v-if="type == 'ppt'">
                            <div class="ppt-container" :class="{ 'ppt-active': !showSlider }">
                                <i class="iconfont icon-shangyiyehoutuifanhui-yuankuang left"
                                    @click="changePagePpt('last')"></i>
                                <i class="iconfont icon-xiayiyeqianjinchakangengduo-yuankuang right"
                                    @click="changePagePpt('next')"></i>
                                <i class="iconfont icon-shuzirenliebiao" @click="openChat"></i>
                                <i v-if="!nPersonRate[currentPptPage - 1]" class="iconfont icon-002jingyin"
                                    @click="changePlayAudio"></i>
                                <i class="iconfont icon-jiazai"
                                    v-else-if="nPersonRate[currentPptPage - 1] && !nPersonRate[currentPptPage - 1].values"></i>
                                <i v-else class="iconfont icon-yuyinbofang" @click="openPlayVideo"></i>
                                <img class="ppt-img"
                                    :src="$severUrl(studyCoursePreview[currentPptPage - 1] ? studyCoursePreview[currentPptPage - 1].filePreviewUrl : '')"
                                    alt="">
                                <div class="bottom-box">
                                    <i style="margin-right: 2.5rem;" @click="changePagePpt('last')"
                                        class="iconfont icon-shangyiye"></i>
                                    <div>第{{ currentPptPage }}张幻灯片，共{{ studyCoursePreview.length }}张</div>
                                    <i style="margin-left: 2.5rem;" @click="changePagePpt('next')"
                                        class="iconfont icon-xiayiye"></i>
                                    <i class="iconfont icon-quanping quanping" @click="openBigScreen"></i>
                                </div>
                            </div>
                        </div>
                        <div class="r-box" v-else-if="type == '视频'">
                            <video class="video-box" id="audio" controls></video>
                        </div>
                        <div class="r-box" style="display: flex;justify-content: center;align-items: center;"
                            v-else-if="type == '图片'">
                            <img style="max-width: 100%;max-height: 100%;" :src="$severUrl(studyCoursePreview)" alt="">
                        </div>
                        <div class="r-box" v-else-if="type == '文档'">
                            <iframe ref="iframe" :src="$severUrl(studyCoursePreview)" style="width: 100%;height: 100%;"
                                frameborder="0"></iframe>
                        </div>
                        <div class="r-box" v-else-if="type == '仿真软件'">
                            <el-tooltip effect="dark" content="全屏" placement="top-start">
                                <i class="iconfont icon-quanping1 software-icon" @click="openBigScreen"></i>
                            </el-tooltip>
                            <iframe ref="iframe1" :class="{ 'big-iframe': isBig }" :src="softwareUrl"
                                style="width: 100%;height: 100%;" frameborder="0"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-content" :class="{ active: !showSlider }">
                <el-tabs v-model="activeName" @tab-click="handClick">
                    <el-tab-pane :label="`目录（${statisticsUnitNum(chapterTree)}）`" name="chapter">
                        <div class="chapter-box">
                            <chapter-tree :currentId="currentId" :tableData="chapterTree"></chapter-tree>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="`试卷（${bindPaper.length}）`" name="paper">
                        <div v-for="(item, index) in bindPaper"
                            :class="[{ 'disabled-btn': !item.authStatus }, { 'item-hover': item.authStatus }]"
                            class="paper-item" @click="viewPaper(item)" :key="index">
                            <el-tooltip class="item" effect="dark"
                                :content="item.authStatus ? item.testPaperName : '暂无权限'" placement="top-start">
                                <div class="overflow"
                                    :class="[{ 'disabled-btn': !item.authStatus }, { 'disabled-color': !item.authStatus }]"
                                    style="flex: 1;">{{ item.testPaperName }}</div>
                            </el-tooltip>
                            <el-tag :type="filterClassify(item.classifyCode).value">{{
                                filterClassify(item.classifyCode).label
                            }}</el-tag>
                        </div>
                        <no-data v-if="bindPaper.length == 0"></no-data>
                    </el-tab-pane>
                    <el-tab-pane :label="`资源（${resourceData.length}）`" name="resource">
                        <div class="res-box" v-if="resourceData.length > 0">
                            <div v-for="(item, index) in resourceData"
                                :class="[{ 'disabled-btn': !item.authStatus }, { 'item-hover': item.authStatus }]"
                                class="res-item" @click="viewResource(item)" :key="index">
                                <img class="img-res" :class="{ 'img-active': !item.authStatus }"
                                    style="width: 1.8rem;height: auto;" :src="filterResIcon(item.type)" alt="">
                                <el-tooltip class="item" effect="dark" :disabled="item.resourceName.length <= 8"
                                    :content="item.authStatus ? item.resourceName : '暂无权限'" placement="top-start">
                                    <div slot="content">
                                        <div v-html="item.resourceName" v-if="item.authStatus"></div>
                                        <div v-else>暂无权限</div>
                                    </div>
                                    <div class="overflow html-box-ev" :class="{ 'disabled-color': !item.authStatus }"
                                        v-html="item.resourceName"></div>
                                </el-tooltip>
                                <el-tag effect="plain"
                                    :style="`color:${resLabelColor(item.type)};border-color:${resLabelColor(item.type)};`">{{
                                        item.type == '仿真软件' ? '软件' : item.type }}</el-tag>
                                <el-tag effect="dark" :type="filterClassify(item.classifyCode).value">{{
                                    filterClassify(item.classifyCode).label
                                }}</el-tag>
                            </div>
                        </div>
                        <no-data v-else></no-data>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <study-resource-preview ref="resource"></study-resource-preview>
        <bullet-sub @submit_success="submitSuccess" ref="bullet_sub"></bullet-sub>
        <div class="preview-big-box" v-if="isBig && type == 'ppt'">
            <div class="ppt-big-box" v-if="type == 'ppt'">
                <i class="iconfont icon-shangyiyehoutuifanhui-yuankuang big-left"
                    @mousedown.left="changePagePpt('last')" @click="changePagePpt('last')"></i>
                <i class="iconfont icon-xiayiyeqianjinchakangengduo-yuankuang big-right"
                    @mousedown.right="changePagePpt('next')" @click="changePagePpt('next')"></i>
                <img :src="$severUrl(studyCoursePreview[currentPptPage - 1] ? studyCoursePreview[currentPptPage - 1].filePreviewUrl : '')"
                    alt="">
            </div>
        </div>
        <deepseek @close="openAi(false)" v-if="aiShow" ref="deepseek"></deepseek>
        <number-person ref="number_person"></number-person>
        <model-chat ref="model_chat"></model-chat>
    </div>
</template>
<script>
import ChapterTree from './courseDetail/ChapterTree.vue';
import { ResourcePreview, GetBindData, GetAllBindData } from '@/api/resourceMag';
import { PageCourseTestPaperList } from '@/api/paper';
import { QueryCopySoftwareDetail } from '@/api/software';
import { GetStudyProgress, UpdateStudyProgress, StudyCourse, AddStudyRecord } from '@/api/study';
import { QueryCourseDetail } from '@/api/course';
import { GetStudyChapterTree } from '@/api/courseChapter';
import Hls from 'hls.js';
import Utils from '@/assets/js/Utils';
import { GetQuestionData } from '@/api/subject';
import NoData from '../common/NoData.vue';
import StudyResourcePreview from './StudyResourcePreview.vue';
import { Category, openVirtual, filterResIcon, resLabelColor } from '@/utils/utils';
import BulletSub from './BulletSub.vue';
import Deepseek from './Deepseek.vue';
import PersonModel from '../common/PersonModel.vue';
import { numberPersonLoading } from './studyCourse/numberPerson';
import NumberPerson from './studyCourse/NumberPerson.vue';
import ModelChat from './studyCourse/ModelChat.vue';
export default {
    components: { ChapterTree, NoData, StudyResourcePreview, BulletSub, Deepseek, PersonModel, NumberPerson, ModelChat },
    data() {
        return {
            aiShow: false,
            isOpen: true,
            /**是否全屏 */
            isBig: false,
            width: window.screen.width,
            /**学习时长 */
            studyTime: 0,
            activeName: 'chapter',
            currentPptPage: 1,
            timer: null,
            timer0: null,
            resourceData: [],
            studyCoursePreview: [],
            /**仿真软件url */
            softwareUrl: '',
            /**开始学习时间戳 */
            startStudyTime: null,
            /**绑定资源 */
            bindResource: [],
            /**全局资源 */
            globalRes: [],
            /**仿真软件进度 */
            studyProgress: {},
            /**章节目录 */
            chapterTree: [],
            /**控制侧边栏的收缩扩张 */
            showSlider: true,
            type: '',
            /**视频总时长 */
            duration: 0,
            /**当前视频播放时间点 */
            currentTime: 0,
            closeMessage: null,
            /**顶部预览资源 */
            preRes: '',
            /**课程已绑定试卷 */
            bindPaper: [],
            /**视频弹题的时间段 */
            videoSubTime: {},
            /**已完成题目时间段 */
            hasFinishSub: {},
            /**仿真模块树 */
            visualTree: [],
            /**是否收起ppt预览侧边栏 */
            isShowSlider: false,
            /**仿真软件id */
            softwareId: '',
            scroolHeight: 0,
            /**是否打开视频结束监听 */
            isWatch: false,
            vFlag: false,
            studyFlag: new Date().getTime(),
            optFlag: new Date().getTime(),
            /**懒加载实例 */
            lazyCase: {
                root: null,
                event: null
            },
            /**是否语音播放 */
            isPlayAudioStatus: 0,
            /**视频加载进度 */
            nPersonRate: {},
            audioElement: null
        }
    },
    methods: {
        filterResIcon,
        resLabelColor, 
        changePlayStatus(value) {
            this.isPlayAudioStatus = value;
        },
        openChat() {
            let dialog = this.$refs.model_chat;
            if (dialog) {
                dialog.getDigitalHumanModelList();
            }
        },
        openPlayVideo() {
            let obj = this.nPersonRate[this.currentPptPage - 1];
            if (!obj.values||obj.values.length==0|| this.audioElement) return;
            let i=Object.keys(obj.values).length-1;
            let current=0;
            let audio = new Audio(obj.values[current]);
            this.audioElement = audio;
            let dom = document.querySelector('.ppt-container');
            dom.appendChild(audio);
            audio.style.position = 'absolute';
            audio.style.bottom = '5rem';
            audio.style.right = '10rem';
            audio.style.zIndex = 999;
            audio.setAttribute('controls', true);
            audio.setAttribute('autoplay', true);
            function monitor(){
                current++;
                if(current<=i){
                    audio.setAttribute('src',obj.values[current]);
                    audio.play();
                }else{
                    audio.removeEventListener('ended',monitor.bind(this));
                }
            };
            audio.addEventListener('ended',monitor.bind(this));
        },
        /**移除audio */
        removeAudio(){
            this.audioElement&&this.audioElement.remove();
            this.audioElement=null;
        },
        changePlayAudio() {
            let url = this.$severUrl(this.studyCoursePreview[this.currentPptPage - 1].filePreviewUrl);
            const loadingRate = (data) => {
                if (this.nPersonRate[data.key] == undefined) {
                    this.$set(this.nPersonRate, data.key, data);
                } else {
                    this.nPersonRate[data.key] = data;
                }
            }
            numberPersonLoading(url, this.currentPptPage - 1, loadingRate).catch(err=>{
                this.$delete(this.nPersonRate,err.key);
            });
        },
        lazyLoad() {
            let parent = document.querySelector('.box-item');
            let flag = true;
            function load() {
                if (!flag) return;
                flag = false;
                setTimeout(() => {
                    const images = document.querySelectorAll('.slider-img-item');
                    images.forEach(img => {
                        if (!img.dataset.src) return;
                        const rect = img.getBoundingClientRect();
                        const rect1 = parent.getBoundingClientRect();
                        if (rect.top < parent.clientHeight + rect1.top && rect.bottom >= 0) {
                            img.src = img.dataset.src;
                            img.removeAttribute('data-src');
                        }
                    });
                    flag = true;
                }, 500)
            };
            this.lazyCase.root = parent;
            this.lazyCase.event = load;
            load();
            parent && parent.addEventListener('scroll', load);
        },
        /**移除懒加载监听 */
        removeLazy() {
            let root = this.lazyCase.root;
            let e = this.lazyCase.event;
            if (root && e) {
                root.removeEventListener('scroll', e);
            }
        },
        /**打开AI互动 */
        openAi(flag) {
            this.aiShow = flag;
        },
        handClick() {
            if (this.activeName == 'resource') {
                this.getAllBindData(this.courseId);
            } else if (this.activeName == 'paper') {
                this.pageCourseTestPaperList();
            } else {
                this.getStudyChapterTree();
            }
        },
        /**新增学习记录 */
        addStudyRecord() {
            let teachingUnitId = localStorage.getItem('currentId');
            if (!teachingUnitId || !this.openCourseId) return;
            let params = {
                "courseId": this.courseId,
                "courseLearningSource": this.courseLearningSource,
                "openCourseId": this.openCourseId,
                "studyFlag": this.courseLearningSource + ':' + this.studyFlag,
                "optFlag": this.optFlag,
                "teachingUnitId": teachingUnitId
            };
            AddStudyRecord(params);
        },
        /**ppt预览跟随页码 */
        previewScrool() {
            const computedFontSize = getComputedStyle(document.documentElement).fontSize;
            const fontSizeValue = parseInt(computedFontSize, 10);
            let img = document.querySelector('.slider-img-item');
            let h = img.clientHeight * (this.currentPptPage - 1) + 2 * fontSizeValue * (this.currentPptPage - 1);
            let element = document.querySelector('.box-item');
            element && element.scrollTo({
                top: h,
                behavior: 'smooth'
            });
        },
        /**打开全屏 */
        openBigScreen() {
            this.openFullscreen();
            this.isBig = true;
        },
        /**统计教学单元数量 */
        statisticsUnitNum(data, sum = 0) {
            data.forEach(item => {
                if (item.children && item.children.length > 0) {
                    sum = this.statisticsUnitNum(item.children, sum);
                } else {
                    sum++;
                }
            })
            return sum;
        },
        changePpt(index) {
            if (this.currentPptPage == index + 1) return;
            this.removeAudio();
            this.currentPptPage = index + 1;
            this.updateStudyProgress(this.type);
            this.getBindData(this.studyCoursePreview[this.currentPptPage - 1].id, 1);
            this.studyTime = 0;
        },
        submitSuccess() {
            var video = document.getElementById("audio");
            video.play();
        },
        /**获取题目详情 */
        getQuestionData(ids) {
            GetQuestionData({ ids }).then(res => {
                if (res.code == 200) {
                    var dialog = this.$refs['bullet_sub'];
                    if (dialog) {
                        dialog.dialogVisible = true;
                        res.data.forEach(item => {
                            if (['单选题', '判断题'].includes(item.questionType)) {
                                item.value = '';
                            } else if (item.questionType == '多选题') {
                                item.value = [];
                            } else if (item.questionType == '填空题') {
                                item.questionOptionVOS.forEach((a) => {
                                    a.value = '';
                                })
                            }
                        })
                        dialog.subData = res.data;
                    }
                }
            })
        },
        /**分页查询课程已绑定试卷 */
        pageCourseTestPaperList() {
            var params = {
                "bindType": 1,
                "courseId": this.courseId,
                "current": 1,
                "size": 9999
            }
            PageCourseTestPaperList(params).then(res => {
                if (res.code == 200) {
                    this.bindPaper = res.data.records;
                }
            })
        },
        /**返回 */
        toBack() {
            let url = localStorage.getItem('course_study_back');
            if (url) {
                this.$router.push(url);
                return;
            }
            this.$router.go(-1);
        },
        /**查看试卷 */
        viewPaper(item) {
            if (!item.authStatus) return;
            var href = window.location.origin + '/course/paper?id=' + item.id + '&courseId=' + this.courseId + '&testPaperSource=test_paper';
            window.open(href, '_blank');
        },
        /**获取所有教学单元 */
        queryAllUnit(data, arr = []) {
            data.forEach(item => {
                if (item.children && item.children.length > 0) {
                    this.queryAllUnit(item.children, arr);
                } else {
                    arr.push(item.id);
                }
            })
            return arr;
        },
        /**根据课程id获取所有已绑定资源 */
        getAllBindData(id) {
            GetAllBindData({ id }).then(res => {
                if (res.code == 200) {
                    this.resourceData = res.data;
                }
            })
        },
        /**过滤资源图标 */
        filterIcon(type) {
            var obj = {
                'ppt': 'icon-file-ppt',
                "视频": 'icon-shipin',
                "模型": 'icon-ic_cebianlan_fangzhenziyuan',
                "动画": 'icon-bim_donghua',
                '仿真软件': 'icon-diannao',
                "文档": 'icon-wendang',
                '题库': 'icon-tiku',
                '图片': 'icon-tupian',
            }
            return obj[type] || '';
        },
        /**过滤所属分类 */
        filterClassify(type) {
            var obj1 = {};
            var obj = {
                'CIS': '',
                'CPC': 'success',
                'CPS': 'info',
                'CIC': 'warning',
                'OTHER': 'danger'
            }
            obj1.value = obj[type];
            var el = Category.find(item => item.value == type);
            if (el) {
                obj1.label = el.label;
            }
            return obj1;
        },
        /**视频播放跳转到某个时间点 */
        skipTo(seconds) {
            var video = document.getElementById("audio");
            if (video) {
                video.currentTime = seconds;
                video.play();
            }
        },
        /**递归获取教学单元 */
        getUnit(data) {
            if (data.children && data.children.length > 0) {
                return this.getUnit(data.children[0]);
            } else {
                return data;
            }
        },
        /**递归查找资源树 */
        queryItem(data, id) {
            for (var item of data) {
                if (item.teachingUnitId == id) {
                    return item;
                } else {
                    if (item.children && item.children.length > 0) {
                        var el = this.queryItem(item.children, id);
                        if (el) return el;
                    }
                }
            }
        },
        /**递归目录树查找第一个有权限章节 */
        handlePageIndex(data) {
            for (let index in data) {
                let children = data[index].children;
                if (data[index].authStatus && (!children || children.length == 0)) return index;
                if (children) {
                    let i = this.handlePageIndex(children);
                    if (i !== undefined) return i;
                }
            }
        },
        /**获取目录树 */
        getStudyChapterTree(callback) {
            var params = {
                "courseId": this.courseId,
                "openCourseId": this.openCourseId,
                "courseLearningSource": this.$route.query.courseLearningSource
            };
            GetStudyChapterTree(params).then(res => {
                if (res.code == 200) {
                    var courseMenuDetailVOList = res.data;
                    this.chapterTree = res.data;
                    if (courseMenuDetailVOList && courseMenuDetailVOList.length > 0) {
                        let index = this.handlePageIndex(courseMenuDetailVOList);
                        var item = JSON.parse(localStorage.getItem('currentStudyItem'));
                        if (item && item.studyStatus == '0') {
                            this.vFlag = false;
                        } else {
                            this.vFlag = true;
                        }
                        var mainResource = {};
                        if (item) {
                            var el = this.queryItem(res.data, item.teachingUnitId);
                            if (el) {
                                mainResource = el;
                            } else {
                                mainResource = this.getUnit(courseMenuDetailVOList[index]);
                            }
                        } else {
                            mainResource = this.getUnit(courseMenuDetailVOList[index]);
                        }
                        localStorage.setItem('currentStudyItem', JSON.stringify(mainResource));
                        this.$store.commit('course/changecurrentUnitId', mainResource.teachingUnitId);
                        localStorage.setItem('currentId', mainResource.teachingUnitId);
                        localStorage.setItem('mainResourceId', mainResource.resourceId);
                        localStorage.setItem('type', mainResource.mainType);
                        this.addStudyRecord();
                        if (['视频', '仿真软件'].includes(mainResource.mainType)) {
                            this.timer && clearInterval(this.timer);
                            this.timer = setInterval(() => {
                                let mainDataType = mainResource.mainType == '视频' ? '视频_' + new Date().getTime() : '视频';
                                this.updateStudyProgress(mainDataType);
                            }, 20000)
                        } else {
                            this.timer && clearInterval(this.timer);
                        }
                        typeof callback == 'function' && callback();
                    }
                }
            })
        },
        /**获取已绑资源 */
        getBindData(nodeId, bindType) {
            var params = {
                "bindType": bindType,
                "nodeId": nodeId,
                "resId": localStorage.getItem('mainResourceId')
            }
            params.teachingUnitId = localStorage.getItem('currentId');
            if (bindType == 0) {
                params.teachingUnitId = localStorage.getItem('currentId');
            }
            GetBindData(params).then(res => {
                if (res.code == 200) {
                    if (bindType) {
                        this.bindResource = res.data;
                    } else {
                        this.globalRes = res.data;
                    }
                    if (bindType == 2) {
                        var videoSubTime = new Object();
                        res.data.forEach(item => {
                            videoSubTime[Math.floor(Number(item.nodeId))] ? videoSubTime[Math.floor(Number(item.nodeId))].push(item.resId) : (videoSubTime[Math.floor(Number(item.nodeId))] = [item.resId]);
                        })
                        this.videoSubTime = videoSubTime;
                    }
                }
            })
        },
        /**仿真软件参数拼接 */
        softwareStr(optSource, resId) {
            if (this.openCourseId) {
                return '?optSource=' + optSource + '&businessId=' + this.openCourseId + '-' + localStorage.getItem('currentId') + '-' + resId + '-' + this.$route.query.courseLearningSource;
            } else {
                return '?optSource=' + optSource + '&businessId=' + this.courseId;
            }
        },
        /**查看资源 */
        viewResource(data) {
            if (!data.authStatus) return;
            if (data.type == '仿真软件') {
                QueryCopySoftwareDetail({ id: data.resId }).then(res => {
                    var url = openVirtual(res.data.url) + this.softwareStr('teaching_unit_bind_drill', data.resId);
                    window.open(url, '_blank');
                })
            } else {
                var dialog = this.$refs.resource;
                if (dialog) {
                    dialog.type = data.type;
                    dialog.resId = data.resId;
                    if (data.type == '题库') {
                        dialog.getUserQuestion(data.resId, () => {
                            dialog.dialogVisible = true;
                        });
                    } else {
                        dialog.resourcePreview(data.resId, () => {
                            dialog.dialogVisible = true;
                        });
                    }
                }
            }
        },
        /**获取学习进度 */
        getStudyProgress() {
            if (!this.openCourseId) return;
            var resId = localStorage.getItem('mainResourceId');
            var teachingUnitId = localStorage.getItem('currentId');
            var params = {
                "courseId": this.courseId,
                "openCourseId": this.openCourseId,
                "resId": resId,
                "teachingUnitId": teachingUnitId,
                "courseLearningSource": this.$route.query.courseLearningSource
            }
            GetStudyProgress(params).then(res => {
                if (res.code == 200) {
                    if (this.type == 'ppt') {
                        this.currentPptPage = res.data.historyProgress.studyProgress || 1;
                        this.previewScrool();
                        this.getBindData(this.studyCoursePreview[(this.currentPptPage == 0 ? this.currentPptPage : this.currentPptPage - 1)].id, 1);
                    } else if (this.type == '视频') {
                        this.skipTo(res.data.historyProgress.studyProgress);
                    } else if (this.type == '仿真软件') {
                        this.studyProgress = res.data.historyProgress;
                    }
                    this.updateStudyProgress(this.type);
                }
            })
        },
        /**收缩扩张侧边栏 */
        changeSlider() {
            this.showSlider = !this.showSlider;
            let dom = document.querySelector('.ppt-container');
            if(dom){
                dom.style.setProperty('--slider',(this.showSlider?'3':'17')+'rem');
            }
        },
        /**m3u8视频播放 */
        playVideo(videoUrl) {
            const audio = document.getElementById("audio");
            audio.addEventListener('loadedmetadata', () => {
                this.duration = Math.floor(audio.duration);
            });
            let that = this;
            function update() {
                that.updateStudyProgress();
                audio.removeEventListener('ended', update);
            }
            if (!this.vFlag) {
                audio.addEventListener('ended', update);
            }
            const hls = new Hls();
            if (Hls.isSupported()) {
                hls.loadSource(this.$severUrl(videoUrl));
                hls.attachMedia(audio);
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                    audio.play();
                });
            } else if (audio.canPlayType("application/vnd.apple.mpegurl")) {
                audio.src = this.$severUrl(videoUrl);
                audio.addEventListener("canplay", function () {
                    audio.play();
                });
            } else {
                console.error("HLS is not supported in this browser");
            }
        },
        /**获取仿真软件详情 */
        querySoftwareDetail(id) {
            this.softwareId = id;
            QueryCopySoftwareDetail({ id }).then(res => {
                if (res.code == 200) {
                    var url = openVirtual(res.data.url);
                    this.visualTree = res.data.softwareModules || [];
                    this.softwareUrl = url + this.softwareStr('teaching_unit_drill', id);
                    window.removeEventListener('message', this.iframeMessage);
                    window.addEventListener('message', this.iframeMessage);
                    this.getStudyProgress();
                    this.getBindData('', 0);
                    this.getBindData('', 3);
                }
            })
        },
        /**递归查找同一个code的数据 */
        handleTreeCode(data, code) {
            for (let item of data) {
                if (item.code == code) {
                    return item;
                } else {
                    this.handleTreeCode(item.children, code);
                }
            }
        },
        iframeMessage(e) {
            let el = this.visualTree.find(item => item.code == e.data.code);
            if (el) {
                this.getBindData(el.id, 3);
            }
        },
        /**资源预览 */
        resourcePreview(id) {
            if (!id || id == 'null') return;
            ResourcePreview({ id }).then(res => {
                if (res.code == 200) {
                    this.studyTime = 0;
                    this.getBindData('', 0);
                    this.getAllBindData(this.courseId);
                    if (this.type == 'ppt') {
                        this.studyCoursePreview = res.data;
                        if (this.openCourseId) {
                            this.getStudyProgress();
                        } else {
                            this.getBindData('', 1);
                            this.previewScrool();
                        }
                    } else if (this.type == '视频') {
                        if (this.openCourseId) {
                            this.getStudyProgress();
                        }
                        var el = res.data.find(item => {
                            return item.fileName == 'index.m3u8'
                        })
                        if (el) {
                            this.playVideo(el.filePreviewUrl);
                        }
                        this.getBindData('', 2);
                    } else {
                        if (this.openCourseId) {
                            this.getStudyProgress();
                        }
                        this.studyCoursePreview = res.data;
                    }
                }
            })
        },
        /**全屏模式 */
        openFullscreen() {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) { /* Firefox */
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                document.documentElement.webkitRequestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) { /* IE/Edge */
                document.documentElement.msRequestFullscreen();
            }
            let that = this;
            // 监听全屏更改事件
            document.addEventListener('fullscreenchange', function () {
                if (!document.fullscreenElement) {
                    that.isBig = false;
                    console.log('已退出全屏模式', this.isBig);
                    // 在这里编写退出全屏后的代码
                }
            });
        },
        changeUnit(e) {
            var item = JSON.parse(localStorage.getItem('currentStudyItem'));
            if (item.id == e.id) return;
            if (e.studyStatus == '0') {
                this.vFlag = false;
            } else {
                this.vFlag = true;
            }
            if (!e.resourceId) {
                this.$msg({
                    showClose: true,
                    message: "该章节未绑定主体资源",
                    type: "warning",
                });
                return;
            }
            this.updateStudyProgress(this.type + new Date().getTime());
            this.addStudyRecord();
            this.$store.commit('course/changecurrentUnitId', e.teachingUnitId);
            localStorage.setItem('currentStudyItem', JSON.stringify(e));
            localStorage.setItem('currentId', e.teachingUnitId);
            localStorage.setItem('mainResourceId', e.resourceId);
            this.type = e.mainType;
            localStorage.setItem('type', e.mainType);
            this.optFlag = new Date().getTime();
            this.addStudyRecord();
            this.removeLazy();
            this.removeAudio();
            if (this.timer) {
                clearInterval(this.timer);
            }
            if (this.type != '仿真软件') {
                this.resourcePreview(e.resourceId);
            } else {
                this.querySoftwareDetail(e.resourceId);
            }
            if (['视频', '仿真软件'].includes(e.mainType)) {
                this.timer && clearInterval(this.timer);
                this.timer = setInterval(() => {
                    let mainDataType = e.mainType == '视频' ? '视频_' + new Date().getTime() : '视频';
                    this.updateStudyProgress(mainDataType);
                }, 20000)
            } else {
                this.timer && clearInterval(this.timer);
            }
        },
        /**ppt翻页 */
        changePagePpt(type) {
            if (type == 'last') {
                if (this.currentPptPage > 1) {
                    this.currentPptPage--;
                    this.updateStudyProgress('ppt');
                    this.studyTime = 0;
                    this.removeAudio();
                } else {
                    this.closeMessage && this.closeMessage.close();
                    this.closeMessage = this.$msg({
                        showClose: true,
                        message: "已经是第一页啦",
                        type: "warning",
                    });
                }
            } else {
                if (this.currentPptPage < this.studyCoursePreview.length) {
                    this.currentPptPage++;
                    this.updateStudyProgress('ppt');
                    this.studyTime = 0;
                    this.removeAudio();
                } else {
                    this.$msg({
                        showClose: true,
                        message: "已经是最后一页啦",
                        type: "warning",
                    });
                }
            }
            this.getBindData(this.studyCoursePreview[this.currentPptPage - 1].id, 1);
            this.previewScrool(type);
        },
        /**获取课程详情 */
        queryCourseDetail() {
            QueryCourseDetail({ id: this.courseId }).then(res => {
                if (res.code == 200) {
                    var data = {
                        label: 'detail',
                        value: res.data
                    }
                    this.$store.commit('course/changeCourseDetail', data);
                }
            })
        },
        /**更新学习进度 */
        updateStudyProgress(mainDataType) {
            if (!this.openCourseId) return;
            var params = {
                "courseId": this.courseId,
                "openCourseId": this.openCourseId,
                "resId": localStorage.getItem('mainResourceId'),
                "studyTime": this.studyTime,
                "mainDataType": mainDataType,
                "teachingUnitId": localStorage.getItem('currentId'),
                "courseLearningSource": this.$route.query.courseLearningSource
            }
            if (this.type == 'ppt') {
                params.studyProgress = {
                    studyProgress: this.currentPptPage,
                    studyProgressTotal: this.studyCoursePreview.length
                };
            } else if (this.type == '视频') {
                params.studyProgress = {
                    studyProgress: this.currentTime,
                    studyProgressTotal: this.duration
                };
            }
            UpdateStudyProgress(params).then((res) => {
                this.studyTime = 0;
                if (this.type == 'ppt') {
                    if (res.data) {
                        this.getStudyChapterTree();
                    }
                } else if (this.type == '视频') {
                    if (this.currentTime == this.duration && !this.vFlag) {
                        this.getStudyChapterTree();
                        this.vFlag = true;
                        this.timer && clearInterval(this.timer);
                    }
                }
            });
        },
        /**仿真软件刷新列表 */
        softwareRefreshList(data) {
            let teachUnitId = localStorage.getItem('currentId');
            let openCourseId = this.openCourseId;
            let softwareId = this.softwareId;
            let arr = data.businessId.split('-');
            if (arr && arr.length >= 3) {
                if (openCourseId == arr[0] && teachUnitId == arr[1] && softwareId == arr[2]) {
                    this.getStudyChapterTree();
                }
            }
        },
        /**开始学习 */
        startStudy() {
            let params = { courseId: this.courseId };
            if (this.openCourseId) {
                params.openCourseId = this.openCourseId;
            }
            StudyCourse(params);
            this.pageCourseTestPaperList();
            this.getAllBindData(this.courseId);
            this.getStudyChapterTree(() => {
                var resourceId = localStorage.getItem('mainResourceId');
                this.type = localStorage.getItem('type');
                if (this.type != '仿真软件') {
                    this.resourcePreview(resourceId);
                } else {
                    this.querySoftwareDetail(resourceId);
                }
            })
        },
        /**键盘左右键控制ppt翻页 */
        keyDown(e) {
            if (this.type != 'ppt') return;
            if (e.keyCode == 37) {
                this.changePagePpt('last');
            } else if (e.keyCode == 39) {
                this.changePagePpt('next');
            }
        },
    },
    computed: {
        courseDetail() {
            return this.$store.state.course.courseDetailData.detail;
        },
        currentId() {
            var id = localStorage.getItem('currentId');
            return this.$store.state.course.currentUnitId || id;
        },
        courseId() {
            return this.$route.query.id || '';
        },
        openCourseId() {
            return this.$route.query.openCourseId || '';
        },
        /**学习来源 */
        courseLearningSource() {
            return this.$route.query.courseLearningSource || '';
        },
        topRes() {
            var arr = [];
            this.bindResource.forEach(item => {
                var index = this.globalRes.findIndex(el => el.originalResId == item.originalResId);
                if (index == -1) {
                    arr.push(item);
                }
            })
            return [...this.globalRes, ...arr];
        }
    },
    mounted() {
        window.addEventListener('keydown', this.keyDown);
        this.pageCourseTestPaperList();
        this.getAllBindData(this.courseId);
        this.queryCourseDetail();
        this.getStudyChapterTree(() => {
            var resourceId = localStorage.getItem('mainResourceId');
            this.type = localStorage.getItem('type');
            if (this.type != '仿真软件') {
                this.resourcePreview(resourceId);
            } else {
                this.querySoftwareDetail(resourceId);
            }
            Utils.$on('change_unit', this.changeUnit);
            this.timer0 = setInterval(() => {
                this.studyTime++;
            }, 1000);
        })
        Utils.$on('course_teaching_unit_complete_msg', this.softwareRefreshList);
        Utils.$on('user-login', this.startStudy);
    },
    beforeRouteLeave(to, from, next) {
        console.log(to, from, '------')
        this.addStudyRecord();
        next();
    },
    destroyed() {
        localStorage.removeItem('currentStudyItem');
        localStorage.removeItem('course_study_back');
        window.removeEventListener('keydown', this.keyDown);
        this.removeLazy();
        Utils.$off('change_unit', this.changeUnit);
        Utils.$off('course_teaching_unit_complete_msg', this.softwareRefreshList);
        Utils.$off('user-login', this.startStudy);
        if (this.timer) {
            clearInterval(this.timer);
            clearInterval(this.timer0);
        }
    }
}
</script>

<style lang="less" scoped>
.box {
    background-color: #F7F7F9;
    width: 100%;
    position: relative;
}

.banner-title {
    color: #151C34;
    font-size: 2.5rem;
    font-weight: 700;
    margin-left: 1.5rem;
}

.tab-container {
    height: 4rem;
    transition: all 0.3s;
    padding-left: 2rem;

    /deep/.el-tabs__nav-wrap::after {
        background-color: transparent;
    }

    /deep/.el-tabs__active-bar {
        background-color: transparent;
    }

    /deep/.el-tabs__header {
        margin: 0;
    }

    /deep/.is-active {
        color: #151C34;
    }

    /deep/.el-tooltip:hover {
        color: #409EFF !important;
    }
}

.banner-course {
    height: 8rem;
    background-color: #ffffff;
    display: flex;
    align-items: center;
}

.grey {
    color: #334681;
    font-size: 1.8rem;
    margin-left: 1rem;
}

.box-content {
    height: calc(100% - 8rem);
    display: flex;
    justify-content: space-between;

    .left-content {
        width: calc(100% - 35rem);
        // padding: 0 0 0 5rem;
        position: relative;
        display: flex;

        .preview-box {
            width: 25rem;
            border-right: 3px solid var(--hr);
        }

        .content {
            width: 100%;
            height: calc(100% - 5rem);
            overflow: auto;
            margin-top: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .r-box-p {
                width: 100%;
                height: 99%;
                display: inline-block;
                position: relative;

                .left {
                    position: absolute;
                    top: 50%;
                    left: calc(var(--slider) + 2rem);
                    transform: translateY(-50%);
                    font-size: 5rem;
                    color: rgba(0, 0, 0, 0.6);
                    cursor: pointer;
                    display: none;
                }

                .right {
                    position: absolute;
                    top: 50%;
                    right:calc(var(--slider) + 2rem);
                    transform: translateY(-50%);
                    font-size: 5rem;
                    color: rgba(0, 0, 0, 0.6);
                    cursor: pointer;
                    display: none;
                }

                .ppt-container {
                    --slider:3rem;
                    display: inline-flex;
                    position: relative;
                    width: 100%;
                    padding: 0 var(--slider) 1rem var(--slider);
                    flex-direction: column;
                    align-items: center;
                }

                .ppt-container:hover>.left {
                    display: block;
                }

                .ppt-container:hover>.right {
                    display: block;
                }

                .ppt-img {
                    // aspect-ratio: 16 / 9 !important;
                    // height: calc(100% - 2.5rem);
                    width: 100%;
                    height: auto;
                    /* 设置宽高比为16:9 */
                    // height: calc(100% - 2.5rem);
                }

                .bottom-box {
                    width: 100%;
                    height: 2.5rem;
                    background-color: #444444;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;

                    i {
                        cursor: pointer;
                    }
                }

            }

            .r-box {
                width: 90%;
                max-height: 99%;
                aspect-ratio: 192 / 108;
                position: relative;

                .software-icon {
                    position: absolute;
                    bottom: 0.5rem;
                    right: -3rem;
                    font-size: 3rem;
                    color: var(--blue);
                    cursor: pointer;
                }

                img {
                    width: 100%;
                    height: calc(100% - 2.5rem);
                }

                .bottom-box {
                    height: 2.5rem;
                    background-color: #444444;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    i {
                        cursor: pointer;
                    }
                }
            }
        }

        .icon-jiantou_xiangyouliangci {
            width: 2.4rem;
            height: 2.4rem;
            background-color: #4C87FF;
            text-align: center;
            line-height: 2.4rem;
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
            transition: all 0.3s;
            font-size: 16px;
        }
    }

    .right-content {
        width: 35rem;
        background-color: #FFFFFF;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        transition: all 0.3s;
        overflow: hidden;
        flex-shrink: 0;
    }
}

.active {
    width: 0 !important;
}

.tranform-active {
    transform: rotate(180deg);
}

.right-content {
    /deep/.el-tabs__nav {
        width: 100%;
    }

    /deep/.el-tabs {
        height: 100%;
    }

    /deep/.el-tabs__item {
        padding-left: 2rem !important;
    }

    /deep/.el-tabs__content {
        height: calc(100% - 6rem);
    }

    /deep/.el-tab-pane {
        height: 100%;
    }
}

.back-box {
    background-image: url('../../assets/image/course/back-box.png');
    height: 100%;
    width: 8rem;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        cursor: pointer;
    }
}

.video-box {
    width: 100%;
    height: 100%;
}

.res-box {
    height: 100%;
    overflow: auto;
}

.res-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #334681;
    cursor: pointer;
    padding: 1.5rem 2rem;

    i {
        font-size: 1.8rem;
        margin: 0 2.5rem;
    }

    &> :nth-child(2) {
        width: calc(100% - 17rem);
    }
}

.paper-item {
    display: flex;
    align-items: center;
    color: #334681;
    cursor: pointer;
    padding: 1.5rem 2rem;

    &> :nth-child(1) {
        flex: 1;
    }
}

.t-res-item {
    display: flex;
    align-items: center;
    color: #334681;
    padding: 0 1.5rem;
    font-size: 16px;
    cursor: pointer;
    padding: 1.5rem 2rem;

    i {
        font-size: 1.8rem;
        margin-right: 0.8rem;
        color: #BCC1D3;
    }
}

.item-hover:hover {
    background-color: var(--blue);
    color: #ffffff;
}

.item-hover:hover>i {
    color: #ffffff;
}

.item-hover:hover>.img-res {
    -webkit-filter: grayscale(100%) brightness(0%) invert(100%) !important;
    /* 兼容旧版WebKit浏览器 */
}

.img-active {
    -webkit-filter: grayscale(100%) !important;
    /* 完全灰度 */
}

.bind-box {
    display: flex;
    align-items: center;
    color: #334681;
    overflow: auto;
    padding: 1.5rem;

    &> :nth-child(n) {
        border-right: 1px solid #BCC1D3;
    }

    &> :last-child {
        border-right: none;
    }
}

.chapter-box {
    height: 100%;
    padding: 0 2rem 0 3rem;
    overflow: auto;
}


.global-box {
    position: fixed;
    top: 15rem;
    left: 0;
    display: flex;
    transition: all 0.3s;

    .box {
        background-color: #ffffff;
        border-top-right-radius: 1.5rem;
        border-bottom-right-radius: 1.5rem;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        padding: 2rem 0;

        .title {
            color: #334681;
            font-weight: 700;
            font-size: 16px;
            text-align: center;
            margin-bottom: 2rem;
        }

        .list-box {
            width: 30rem;
            height: 55rem;
            overflow: auto;
        }
    }

    .open-btn {
        width: 4rem;
        height: 8rem;
        background-color: #ffffff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        color: black;
        cursor: pointer;
        display: flex;
        align-items: center;
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
        justify-content: center;
        margin-top: 25rem;
        transition: all 0.3s;

        i {
            font-size: 2rem;
        }
    }
}

.active-tranform {
    transform: translateX(-30rem);
}

.active-i {
    transform: rotate(180deg);
}

.html-box-ev {
    display: flex;
    align-items: center;
    font-size: 16px;

    & :nth-child(n) {
        display: flex;
        align-items: center;
        font-size: 16px;
    }

    /deep/ img {
        max-width: 2rem !important;
        max-height: 2rem !important;
        width: auto;
        height: auto;
    }
}

.active-100 {
    width: 100% !important;
}

.slider {
    position: absolute;
    width: 5rem;
    height: 10rem;
    left: 20rem;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 0 1rem 1rem 0;
    background-color: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(0, 0, 0);
    font-size: 2rem;
    cursor: pointer;
    transition: all 0.3s;
}

.slider-box {
    width: 23rem;
    height: 100%;
    margin-right: 3rem;
    z-index: 99;
    padding: 1rem;
    transition: all 0.3s;

    .box-item {
        width: 100%;
        height: 100%;
        overflow: auto;
        display: flex;
        flex-direction: column;

        &> :nth-child(n) {
            margin-top: 2rem;
        }

        &> :nth-child(1) {
            margin-top: 0;
        }

        .ppt-img-item {
            width: 100%;
            position: relative;

            .progress-line {
                position: absolute;
                left: 1rem;
                top: 1rem;
                z-index: 99;
                width: 80%;
            }

            .icon-yiwancheng {
                position: absolute;
                left: 1rem;
                top: 1rem;
                color: rgb(103, 194, 58);
                font-size: 2.5rem;
            }
        }

        .slider-img-item {
            width: calc(100% - 10px);
            height: auto;
            cursor: pointer;
            border: 4px solid var(--hr);
        }
    }
}

.active-ppt {
    border: 4px solid var(--blue) !important;
}

.slider-active {
    transform: translate(-20rem, -50%);
}

.ppt-active {
    padding: 0 var(--slider) !important;
}

.preview-big-box {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;

    .software-big-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ppt-big-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;

        .big-left {
            position: absolute;
            top: 50%;
            left: 3rem;
            transform: translateY(-50%);
            z-index: 9999;
            font-size: 5rem;
            color: rgba(0, 0, 0, 0.6);
            cursor: pointer;
        }

        .big-right {
            position: absolute;
            top: 50%;
            right: 3rem;
            transform: translateY(-50%);
            z-index: 9999;
            font-size: 5rem;
            color: rgba(0, 0, 0, 0.6);
            cursor: pointer;
        }

        img {
            width: 100%;
            height: auto;
        }
    }
}

.quanping {
    position: absolute;
    right: 2rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 9;
    cursor: pointer;
    font-size: 16px;
}

.big-iframe {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vh;
    z-index: 999;
}

#disabled-color:hover {
    color: #C0C4CC !important;
}

.icon-shuzirenliebiao {
    position: absolute;
    left: calc(var(--slider) + 3rem);
    bottom: 6rem;
    font-size: 3rem;
    cursor: pointer;
    color: var(--blue);
}

.icon-yuyinbofang {
    position: absolute;
    right: calc(var(--slider) + 3rem);
    bottom: 6rem;
    font-size: 3rem;
    cursor: pointer;
    color: var(--blue);
}

.icon-002jingyin {
    position: absolute;
    right: calc(var(--slider) + 3rem);
    bottom: 6rem;
    font-size: 3rem;
    cursor: pointer;
    color: var(--red);
}

.icon-jiazai {
    position: absolute;
    right: calc(var(--slider) + 3rem);
    bottom: 6rem;
    font-size: 3rem;
}
@media screen and (max-width:750px){
    .box-content{
        display: block;
        overflow: auto;
    }
    .preview-box{
        display: none;
    }
    .show-content-box{
        width: 100% !important;
    }
    .right-content{
        width: 100% !important;
        margin-top: 2rem;
        padding-bottom: 1.5rem;
    }
    .left-content{
        width: 100% !important;
        padding: 0 !important;
    }
    .back-box{
        img{
            margin-left: 1rem;
        }
    }
    .banner-title{
            max-width: 35rem;
        }
    .ai-cursor{
            margin-left: 2rem !important;
        }
    .icon-jiantou_xiangyouliangci{
        display: none;
    }
}
</style>